(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/authorization/assets/javascript/prescript.js') >= 0) return;  svs.modules.push('/modules/authorization/assets/javascript/prescript.js');

'use strict';

svs.authorization = svs.authorization || {};
svs.authorization.data = svs.authorization.data || {};
svs.authorization.data.error = svs.authorization.data.error || {};
svs.authorization.data.success = svs.authorization.data.success || {};
svs.authorization.data.sessionData = svs.authorization.data.sessionData || {};
svs.authorization.logger = new svs.core.log.Logger('modules:authorization');

 })(window);